import React from 'react';
import { useTranslation } from '../../contexts/LanguageContext';

const ThemePackSelector = ({ applyThemePack, applyRandomThemePack, themePacks = [] }) => {
  const { t } = useTranslation();

  return (
    <section className="settings-section theme-packs-section">
      <h3>🎨 {t('settings.themePacks', 'Theme Packs')}</h3>
      <p className="section-description">{t('settings.themePacksDescription', 'One-click complete visual themes')}</p>
      
      {themePacks.length === 0 ? (
        <div style={{
          padding: '16px',
          textAlign: 'center',
          color: '#999',
          fontSize: '13px',
          background: '#f5f5f5',
          borderRadius: '10px'
        }}>
          No theme packs available with your current skins
        </div>
      ) : (
        <>
          <button 
            className="random-theme-btn"
            onClick={applyRandomThemePack}
            data-testid="random-theme-pack-btn"
            style={{
              width: '100%',
              padding: '12px 20px',
              marginBottom: '15px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '14px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
              transition: 'all 0.3s ease'
            }}
          >
            🎲 {t('settings.randomThemePack', 'Random Theme Pack')}
          </button>

          <div className="theme-pack-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
            gap: '12px'
          }}>
            {themePacks.map((pack) => (
              <button
                key={pack.id}
                className="theme-pack-card"
                onClick={() => applyThemePack(pack)}
                data-testid={`theme-pack-${pack.id}`}
                style={{
                  padding: '12px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '10px',
                  background: 'white',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  textAlign: 'center'
                }}
              >
                <div style={{ fontSize: '20px', marginBottom: '6px' }}>
                  {pack.name.split(' ')[0]}
                </div>
                <div style={{ 
                  fontSize: '11px', 
                  fontWeight: '600',
                  color: '#333',
                  lineHeight: '1.3'
                }}>
                  {pack.name.split(' ').slice(1).join(' ')}
                </div>
                <div style={{ 
                  fontSize: '9px', 
                  color: '#666',
                  marginTop: '4px'
                }}>
                  {pack.description}
                </div>
              </button>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default ThemePackSelector;
